import React from 'react';
import { connect } from 'react-redux';
import { getToast } from '../reducers/app/toast';
import { Toast } from '../Ui';

const styles = {
	position: 'fixed',
	bottom: '76px',
	right: 0,
	marginRight: '16px'
};

const Toaster = ({ toasts }) => {
	return (
		<div style={styles}>
			{toasts.map(toast => <Toast {...toast.props} key={toast.id} />)}
		</div>
	);
};

export default connect(state => ({ toasts: getToast(state) }))(Toaster);



// WEBPACK FOOTER //
// ./src/js/app/Toaster.js